// John Eldhose 20180511
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Divider, Grid, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

class NotFound extends Component {
  render() {
    return (
      <div>
        <p />
        <Typography variant='display1'>
          <font color='black'>
            <FormattedMessage
              id='Page not found'
              defaultMessage='Page not found'
            />
          </font>
        </Typography>
        <p />
        <Divider />
        <p />
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Button component={Link} to='/' fullWidth>
              <FormattedMessage
                id='Return to Account Home'
                defaultMessage='Return to Account Home'
              />
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js